import PhoneInput from "react-phone-number-input";

/**
 *a phone input with multiple contries
 * @param {number} value
 * @param {string} placeholder
 * @param {() => {}} onChange
 * @returns
 */
function InputPhone({ value, onChange, placeholder }) {
  return (
    <PhoneInput
      defaultCountry="CM"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  );
}

export default InputPhone;
